import { render } from "./AdminSubMenu.vue?vue&type=template&id=73cd87e4"
import script from "./AdminSubMenu.vue?vue&type=script&lang=js"
export * from "./AdminSubMenu.vue?vue&type=script&lang=js"

import "./AdminSubMenu.vue?vue&type=style&index=0&id=73cd87e4&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__